<template>
	<div>
		<div style="padding: 20px;background: white;width: calc(100% - 40px);height: 800px;">
			<div>工具箱</div>
			<ul style="justify-content: flex-start;">
				<template v-for="(item,inde) in operatelist">
					<li :key="item.id" class="tools-box-item holdlist textcenter" @click="goto(inde)" v-if="hasAccess('200696')">
						<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
							<span  v-for="(citem,index) in item.event_detail" :key="citem.title" v-if="index < (item.event_detail.length - 1)">
								{{ citem.title }} +
							</span> 
							<span v-else-if="index == (item.event_detail.length - 1)" >
								{{ citem.title }}
							</span> 
						</div>
						<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
							{{ item.desc }} 
						</div>
					</li>
				</template>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/new/email')" v-if="hasAccess('200697')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>批量发送邮件</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						可以批量导入邮箱，设置html样式发送
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/new/set-lock-screen')" v-if="hasAccess('200724')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>锁屏工具包下载链接更新</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left; cursor: pointer;">
						当工具新版本更新时，上传新包，对[锁屏制作]项目的工具下载链接更新。
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/new/link-config')" v-if="hasAccess('200734')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>友情链接配置</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" v-if="hasAccess('200736')" @click="goFn('/luck-draw/luck-draw-programme')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>抽奖方案</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						配合个性化活动配置的抽奖功能
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" v-if="hasAccess('200815')" @click="goFn('/new/temporary-authority')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>价格审批权限临时分配</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						将价格审批权限临时分配给其他人员;
						包含项目验收审核、摄影投稿作品审核。
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('invite-friends-reward-settings')" v-if="hasAccess('200722')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>[拉新]好友行为奖励设置</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						每个用户拉新用户入驻平台，可获得奖励设置，以及项目收益提成比例
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/business-manage/business-process')" v-if="hasAccess('201178')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>业务流程管理</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						项目验收、摄影投稿审核项的审核流程设置（多人或审）、定价设置
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/apk/display-object')" v-if="hasAccess('241')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>演示demo，apk配置管理</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						新视界apk演示资源分类、资源包配置
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/expediting')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>投稿 催审&催稿上线 配置与查询</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						可配置用户投稿的催审时间条件周期；
						可查看用户的申请崔审记录
					</div>
				</li>
				<!-- <li class="tools-box-item holdlist textcenter" @click="goFn('/apk/display-object')" v-if="hasAccess('201178')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>111</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						111
					</div>
				</li> -->
				<li class="tools-box-item holdlist textcenter" @click="goFn('/classList')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>分类树</span> 
					</div>
					<div style="width: 80%;margin: auto; color: #FFFFFF;text-align: left;">
						可查看分类树；
					</div>
				</li>
				<li class="tools-box-item holdlist textcenter" @click="goFn('/workpush/indexs')">
					<div style="margin: 27px auto 13px;width: 80%;color: #FFFFFF;">
						<span>作品发布审核机制</span> 
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { hasAccess } from '../../common/utils'

	export default {
		data(){
			return{
				operatelist:{},
				adminuseraccess:[],
				hasAccess
			}
		},
		methods:{
			checkAss(id){
				return this.adminuseraccess.indexOf(id) != -1;
			},
			goFn(path){
				this.router.push({path})
			},
			goto(id){
				if(this.adminuseraccess.indexOf("200396") == -1){
					this.$message({
						message:"没有查看权限"
					})
					return;
				}
				
				
				this.router.push({
					path:"/contentManager/holdAll/holdAlltab",
					query:{
						data:JSON.stringify(this.operatelist[id])
					}
				})
			},
			getoperatelist(){
				this.api.operatelist({
					access_token:localStorage.getItem("access_token	")
				}).then(da=>{
					this.operatelist= da;
				})
			}
		},
		created() {
			this.getoperatelist()
		},
		mounted(){
			if(localStorage.getItem("adminuseraccess")){
				this.adminuseraccess = JSON.parse(localStorage.getItem("adminuseraccess"))
			}
		}
	}
</script>

<style lang="scss" scoped>
	.holdlist{
		width: 288px;
		height: 150px;
		margin: 5px;
		color: #FFFFFF;
		background: url(../../../public/img/icons/JL_bg.svg) center center no-repeat;
		&.tools-box-item {
			display: inline-block;
			vertical-align: top;
		}
		&:hover {
			cursor: pointer;
		}
	}
</style>